export enum PaymentResultErrorTypeEnum {
    STRIPE_CARD_SUBMIT_ERROR,
    PAYMENT_METHOD_ID_SEND_ERROR,
    POST_SUBSCRIPTION_ERROR,
}